module.exports = __webpack_public_path__ + "img/lastmile_logo.703b8ebd.svg";